import customAxios from "../../customAxios";
import { DELETE_WORK_TIME } from "../../routes";

const deleteWorkTime = async (id: string) => {
  try {
    return (await customAxios.delete(DELETE_WORK_TIME + `/${id}`)).data;
  } catch (error: any) {
    console.log({ DELETE_WORK_TIME: error });
    return false;
  }
};

export default deleteWorkTime;
